import { render, staticRenderFns } from "./sectionEdit.vue?vue&type=template&id=374f90b1&"
import script from "./sectionEdit.vue?vue&type=script&lang=js&"
export * from "./sectionEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports